import * as firebase from 'firebase'
import { store } from '..'
import gsap from "gsap";
export default {
  state: {
    user: null,
    admin: false,
    curator: false,
    userData: null,
    entryUrl:null,
    userLoading:false,
    userIsLoaded:false,
    showSignIn:false,
    loginNag:true,
    exhibitionLoaded:false,
    fireBaseLoc:"https://storage.googleapis.com/wreckseeker-anmm.appspot.com/"

  },
  mutations: {
    setExhibitionLoaded(state,payload){
      state.exhibitionLoaded=payload
    },
    setShowSignIn(state,payload){
      state.showSignIn=payload
    },
    setLoading(state,payload){
        state.userLoading=payload
    },
    setLoginNag(state,payload){
      state.loginNag=payload
    },
    setUserIsLoaded(state,payload){
      state.userIsLoaded=payload
    },
    setEntryUrl(state,payload){
      state.entryUrl=payload
    },
    setUserData(state, payload) {
      console.log("====== DATA SET TO",payload)
      state.userData = payload
    },
    setAdmin(state, payload) {
      state.admin = payload
    },
    setCurator(state, payload) {
      state.curator = payload
    },

    assignContentToUser(state, payload) {
      const id = payload.id
      state.user.fbKeys[id] = payload.fbKey
    },

    setUser(state, payload) {
      state.user = payload
    },
    

  },
  actions: {

    savePhoto({commit,getters},payload){
      let userId=getters.user.id
      let wreckName=getters.getActiveWreck
      let imageIndex=getters.getWreckPhotos.length
        return firebase.storage().ref('/userpics/'+userId+"/"+wreckName).child('photo'+imageIndex).putString(payload, 'data_url', {contentType:'image/jpg'}).then((snap) => {
        return snap.ref.getDownloadURL();
      })
      .then(downloadURL => {
        console.log('Image uploaded',downloadURL);
        
        commit('addPhoto',downloadURL)
        return downloadURL
        
      })
      .catch(error => {
        console.log(`An error occurred while uploading the file.\n\n${error}`);
      });
       
     
      
    },
    saveExhibition({ dispatch, commit, getters }) { 
      if( !getters.user){
        alert("no user")
          return
        }
        let updateObj=getters.getExhibitLayout
        updateObj.userID=getters.user.id
        firebase.firestore().collection("exhibitions").doc(getters.getActiveWreck).collection(getters.user.id).doc("exhibition").set(updateObj)
      .then(function() {
          console.log("Document successfully written!");
      })
      .catch(function(error) {
          console.error("Error writing document: ", error);
      });  
    },
    saveGameState({ dispatch, commit, getters }) {  
      if( !getters.user){
      // alert("no user")
        return
      }
      
      console.log("SAVE DATA",getters.getWreckStatus)
      var content = firebase.firestore().collection("users").where("id", "==", getters.user.id)
     
      content.get().then(function(querySnapshot) {
        querySnapshot.forEach(function(doc) {
          //console.log(doc.id, ' => ', doc.data());
        let updateObj={
          plays:getters.getUserData.plays,
          gameStatus:getters.getGameStatus,
          wreckStatus:getters.getWreckStatus,
          shownHelp:getters.getShownHelps
        }
        console.log("WRECK STATUS",getters.getWreckStatus)
         //if(getters.getWreckStatus){
        updateObj.wreckStatus=getters.getWreckStatus || null
          //updateObj.knownDocs=getters.getKnownDocs
        // }
         if(getters.getViewedDocs){
          updateObj.viewedDocs=getters.getViewedDocs
         }
          firebase.firestore().collection("users").doc(doc.id).update(updateObj)
            .then(function() {
              console.log("state saved")

            })
            .catch(function(error) {
              // The document probably doesn't exist.
             
              console.error("Error updating document: ", error);
            });

        });
      });


    },
   
    signUserUp({ dispatch,commit }, payload) {
      commit('setLoading', true)
      //commit('clearError')
      firebase
        .auth()
        .createUserWithEmailAndPassword(payload.email, payload.password)
        .then(user => {
         
          commit('setLoading', false)
          console.log("SIGNED UP", user, user.user.uid);
          const newUser = {
            //id: user.uid,
            id: user.user.uid,
            admin: false,
            user: true,
            name:payload.displayName,
            plays:0
          }
          var cuser = firebase.auth().currentUser;
          cuser.updateProfile({
            displayName: payload.displayName
             }).then(function() {
            console.log("NAME  Update successful.")
            }, function(error) {
           console.log("NAME  Update broken.",error)
             }); 
          firebase.firestore().collection("users").add(newUser)
            .then(function(docRef) {
              dispatch('sendVerificationEmail')
              console.log("Document written with ID: ", docRef.id);
              console.log("AUTO SIGN IN",payload)
            })
            .catch(function(error) {
              console.error("Error adding document: ", error);
            });
        })
        .catch(error => {
          commit('setLoading', false)
          commit('setError', error)
          console.log(error)
        })
    },

    signUserIn({ commit }, payload) {
        console.log("SIGN IN",payload)
     // commit('setLoading', true)
     // commit('clearError')
      firebase
        .auth()
        .signInWithEmailAndPassword(payload.email, payload.password)
        .then(user => {
            console.log("SIGN IN2",user)
         // commit('setLoading', false)
          const newUser = {
            id: user.uid
          }
          commit('setUser', newUser)
        })
        .catch(error => {
        //  commit('setLoading', false)
        //  commit('setError', error)
          console.log(error)
        })
    },
    signUserOut({ commit }){
      firebase.auth().signOut().then(function() {
        // Sign-out successful.
        commit('setUser', null)
        
        location.reload();
      }, function(error) {
        // An error happened.
      });
      
    },
    sendVerificationEmail(){
      var user = firebase.auth().currentUser;
          user.sendEmailVerification().then(function() {
            console.log("EMAIL SENT")
          }).catch(function(error) {
            // An error happened.
          });
    },
    forgotPassword({},emailAddress){
      var auth = firebase.auth();
      console.log("forgot",emailAddress)
      auth.sendPasswordResetEmail(emailAddress).then(function() {
          // Email sent.
          console.log("EMAIL SENT")
        }).catch(function(error) {
          // An error happened.
        });
    },
    autoSignIn({ dispatch, commit, getters }, payload) {
      console.log("AUTO SIGN IN",getters.entryUrl)
      console.log(payload)
      commit('setUser', { id: payload.uid, displayName:payload.displayName,email:payload.email })
      dispatch('fetchUserData')
    },
    getExhibition({dispatch,commit, getters }){
      if( !getters.user){
       console.log("NO EXHIBITION NOT LOGGED IN")
          return
        }
      commit('setLoading', true)
      console.log("LOAD EXHIBITION NOT LOGGED IN",getters.getActiveWreck)
      var content = firebase.firestore().collection("exhibitions").doc(getters.getActiveWreck).collection(getters.user.id).get().then(querySnapshot => {
        if(!querySnapshot.empty){
          console.log("QUERY DATA",querySnapshot)
        querySnapshot.forEach(doc => {
            console.log(doc.id, " => ", doc.data());
            commit('setExhibitLayout',doc.data())
            commit('setExhibitionLoaded',true)
        })
      }else{
        console.log("QUERY NO DATA")
        commit('setExhibitLayout',{})
        commit('setExhibitionLoaded',true)
        //commit('setExhibitionLoaded',true)
      }
        
    }).catch(err => {
      console.log('Error logged', err);
  })
     
    },
    getPublicExhibition({dispatch,commit, getters },payload){
      
      commit('setLoading', true)
      console.log("LOAD EXHIBITION NOT LOGGED IN",payload.wreck)
      var content = firebase.firestore().collection("exhibitions").doc(payload.wreck).collection(payload.uid).get().then(querySnapshot => {
      if(!querySnapshot.empty){
          console.log("QUERY DATA",querySnapshot)
            querySnapshot.forEach(doc => {
            console.log(doc.id, " => ", doc.data());
            commit('setExhibitLayout',doc.data())
            commit('setExhibitionLoaded',true)
        })
      }else{
        console.log("QUERY NO DATA")
        commit('setExhibitLayout',{})
        commit('setExhibitionLoaded',true)
        //commit('setExhibitionLoaded',true)
      }
        
    }).catch(err => {
      console.log('Error logged', err);
  })
     
    },
    fetchUserData({ dispatch,commit, getters }) {
      commit('setLoading', true)
      var content = firebase.firestore().collection("users").where("id", "==", getters.user.id)
      content.get().then(function(querySnapshot) {
        querySnapshot.forEach(function(doc) {
          console.log(doc.id, ' => ', doc.data());
          commit('setUserData', doc.data())
          dispatch('applyUserData',doc.data())
         
        });
        commit("setUserIsLoaded",true)
        
        commit('setLoading', false)
      });
    },
    updateUserData({dispatch,commit,getters},payload){
      console.log("UPDATE USER DATA",payload)
      let usrData=getters.getUserData
      let newData
      if(usrData){
        newData=Object.assign(usrData, payload);
      }else{
        newData=payload
      }
      
      console.log("newData",newData)
      commit('setUserData', newData)
      dispatch('saveGameState')
    },
    clearGame({ dispatch, commit}) {
     commit('setWreckStatus',null)
     commit('setViewedDocs',null)
     alert("game wiped")
     dispatch('saveGameState')

   },
    loadSavedState({ dispatch, commit, getters}){
        let value=getters.getUserData
        let prevRep=0
        console.log("USER DATA",value)
        alert("LOAD SAVED")
        commit("setUserIsLoaded",true)
    },
    logout({ commit }) {
      firebase.auth().signOut()
      commit('logout')
      
       

    }
  },
  getters: {
    getExhibitionLoaded(state){
      return state.exhibitionLoaded
    },
    showSignIn(state){
      return state.showSignIn
    },
    getLoginNag(state){
      return state.loginNag
     },
    user(state) {
      return state.user
    },
    getUserIsLoaded(state) {
      return state.userIsLoaded
    },
    getUserData(state) {
      return state.userData
    },
    userAdmin(state) {
      return state.admin
    },
    userCurator(state) {
      return state.curator
    },
    entryUrl(state){
      return state.entryUrl
    },
    getFireBaseLoc(state){
      return state.fireBaseLoc
    },
    getFireBaseWrecks(state){
      return state.fireBaseLoc+"wrecks%2F"
    }


  },


}